module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../../static/assets/include/svg/svg-bg1.svg')",
      "background-attachment": "fixed"
    }
  }, [_vm._m(0), _vm._v(" "), _c('help-block')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-lg-between align-items-center"
  }, [_c('div', {
    staticClass: "col-md-6 g-mt-70 g-mb-0--md"
  }, [_c('img', {
    staticClass: "img-fluid u-shadow-v39 g-brd-around g-brd-10 g-brd-white rounded",
    attrs: {
      "src": require("../../../../static/assets/img/FamilyImages/Portal Photo_FamilyImage1.jpeg"),
      "alt": "Image Description"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "g-mt-20 text-center"
  }, [_c('h1', {
    staticClass: "mb-3"
  }, [_vm._v("Help Page")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("We’re here to support you, whether that’s through hardware or knowledge.")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-83a5147a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83a5147a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/helpData/HelpArticle.vue
// module id = 532
// module chunks = 3